import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullBasket from "../fragments/fullBasket"

const query = gql`
  mutation UpdateBasket($userId: ID!, $basket: BasketInput) {
    updateBasket(userId: $userId, basket: $basket) {
      ...fullBasket
    }
  }
  ${fullBasket}
`

export const updateBasketKey = getQueryNames(query)[0]

export default query
